import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const ToggleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
`;
